import RootStore from '@/store/RootStore';
import { reaction } from 'mobx';

interface BaseStore {
  rootStore: typeof RootStore;
}

export function onCurrentStationChange(This: unknown, callback: () => void) {
  const store = This as BaseStore;
  reaction(
    () => store.rootStore.stationStore?.currentStation.id,
    callback
  )
}

